import { types as actionTypes } from './waiverToChangeAssociationActions';
import { Action } from '../../../types';
import { Waiver } from '../../../../types/waiver';

export type WaiverToChangeAssociationState = {
  waiver?: Waiver;
};

const initialState: WaiverToChangeAssociationState = {
  waiver: undefined,
};

export default function reducer(
  state: WaiverToChangeAssociationState = initialState,
  action: Action<Waiver | undefined>,
): WaiverToChangeAssociationState {
  switch (action.type) {
    case actionTypes.START:
      return {
        waiver: action.response,
      };
    case actionTypes.END:
      return {
        waiver: undefined,
      };
    default:
      return state;
  }
}
